import { ActionContext, ActionTree } from "vuex";
import { MutationPickYourOwnColor } from "./mutations";
import { PickYourOwnColorStoreState } from "./pickYourOwnColor.t";
import {
  ActionTypesPickYourOwnColor
} from "./types";

type AugmentedActionContextPickYourOwnColor = {
  commit<K extends keyof MutationPickYourOwnColor>(
    key: K,
    payload: Parameters<MutationPickYourOwnColor[K]>[1]
  ): ReturnType<MutationPickYourOwnColor[K]>;
} & Omit<ActionContext<PickYourOwnColorStoreState, any>, "commit">;

export interface ActionsPickYourOwnColor {
  [ActionTypesPickYourOwnColor.LOAD_COLORS](
    {}: AugmentedActionContextPickYourOwnColor
  ): Promise<string[]>;

  [ActionTypesPickYourOwnColor.SAVE_COLORS](
    {}: AugmentedActionContextPickYourOwnColor,
    payload: string[]
  ): Promise<void>;
}

const actions: ActionTree<PickYourOwnColorStoreState, any> &
  ActionsPickYourOwnColor = {
  [ActionTypesPickYourOwnColor.LOAD_COLORS](
    {}
  ) {
    const encodedColors = localStorage?.getItem("yourColors");
    const colors = encodedColors ? JSON.parse(encodedColors) : [];
    return Promise.resolve(colors);
  },
  [ActionTypesPickYourOwnColor.SAVE_COLORS](
    {},
    payload
  ) {
    const encodedColors = JSON.stringify(payload);
    localStorage?.setItem("yourColors", encodedColors);
    return Promise.resolve();
  },
};

export default actions;
